module.exports = __webpack_public_path__ + "112676bfc2407fcd3a270afea563d6d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/valorant/bind.png
// module id = 444
// module chunks = 0